import { useMemo } from 'react'
import { BottomNav, Navigation, useNavigationContext } from '@panwds/react-nav'
import builtInActions from './builtInActions'
import NavActions from './NavActions'
import { getDisplayNavItems, mergeActions } from './navUtils'
import './LeftNav.scss'
import type { VFC } from 'react'
import type { StoreState, Vars, OidcState } from '../../framework/stateTypes'
import type { NavItem } from '../../framework/microAppTypes'

type BottomNavProps = {
  state: StoreState
  vars: Vars
  oidc: OidcState | undefined
  activeNavItem: NavItem | undefined
  activeSubNavItem: NavItem | undefined
}

const BottomNavigation: VFC<BottomNavProps> = ({ state, vars, oidc, activeNavItem, activeSubNavItem }) => {
  const context = useNavigationContext()
  const isSideNavCollapsed = context?.collapsed
  const isPrivateSite = Boolean(vars.private_site_origin)
  const showNonMspActions = vars.msp_tenant_switcher || vars.sase || vars.hub || isPrivateSite ? undefined : true

  const actions = useMemo(() => {
    const copiedActions = state.leftMainActions?.slice() || []
    if (!showNonMspActions) {
      copiedActions.push(...builtInActions({ isPrivateSite, isSideNavCollapsed, oidc, preferences: state?.preferences, vars }))
    }
    const isEarlyLoad = (state.leftMainActions as any)?._action_early_init
    const merged = mergeActions(copiedActions).map(action => {
      if (action.hidden && action.navComponent) {
        return { ...action, hidden: false, _hidden: true }
      }
      return action
    })
    const filtered = isEarlyLoad ? merged.filter(action => action._action_early_init) : merged
    const actions = getDisplayNavItems(filtered as NavItem[])
    for (const action of actions) {
      if (action._hidden) {
        action.hidden = true
        delete action._hidden
      }
    }
    return actions
  }, [isSideNavCollapsed, state, oidc, vars, isPrivateSite, showNonMspActions])
  return (
    <BottomNav addClassName='sparky-nav-bottom spf-flex-grow-0 spf-w-full spf-overflow-hidden oneapp-nav-actions'>
      <NavActions isSideNavCollapsed={isSideNavCollapsed} actions={actions} state={state} activeNavItem={activeNavItem} activeSubNavItem={activeSubNavItem} />
    </BottomNav>
  )
}

export const HubHiddenNav: VFC<Pick<BottomNavProps, 'state' | 'vars'>> = ({ state, vars }) => {
  const actions = useMemo(() => {
    const copiedActions = state.leftMainActions?.slice() || []
    const filtered = copiedActions.filter(action => action.key === 'tenant-switcher' && action.navComponent)
    return filtered
  }, [state])

  if (!vars.hub || !actions.length) {
    return null
  }
  return <Navigation logoUrl={'/'} hasCollapseController={false} addClassName='spf-hidden'>
    <BottomNav addClassName='sparky-nav-bottom spf-hidden oneapp-nav-actions'>
      <NavActions isSideNavCollapsed={false} actions={actions} state={state} />
    </BottomNav>
  </Navigation>
}

export default BottomNavigation
